<div class="row mb-4">
    <div class="col-sm-12 mx-auto">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <h4 class="card-title col-12 mb-4">Create STROOP Test</h4>
                    <form #theForm="ngForm" (ngSubmit)="submitForm(formGroup)" novalidate class="col-12">
                        <div [formGroup]="formGroup">
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Type</label>
                                </div>
                                <div class="col-md-8">
                                    <div class="form-check">
                                        <input class="form-check-input" formControlName="type" type="radio" value="congruent" id="type-pre" required>
                                        <label class="form-check-label" for="type-pre">
                                            Congruent
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" formControlName="type" type="radio" value="incongruent" id="type-post" required>
                                        <label class="form-check-label" for="type-post">
                                            Incongruent
                                        </label>
                                    </div>
                                    <div class="text-danger" *ngIf="formGroup.get('type')?.invalid && (theForm.submitted || formGroup.get('type')?.touched)">
                                        <small *ngIf="formGroup.get('type')?.errors?.required">Select type</small>
                                        <small *ngIf="formGroup.get('type')?.errors?.serverError">{{formGroup.get('type')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Point</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="number" formControlName="point" class="form-control" [class.is-invalid]="formGroup.get('point')?.invalid && (theForm.submitted || formGroup.get('point')?.touched)" placeholder="Type point" required>
                                    <div class="text-danger" *ngIf="formGroup.get('point')?.invalid && (theForm.submitted || formGroup.get('point')?.touched)">
                                        <small *ngIf="formGroup.get('point')?.errors?.required">Type point</small>
                                        <small *ngIf="formGroup.get('point')?.errors?.serverError">{{formGroup.get('point')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Text</label>
                                </div>
                                <div class="col-md-8">
                                    <select formControlName="color_name_id" class="form-select" [class.is-invalid]="formGroup.get('color_name_id')?.invalid && (theForm.submitted || formGroup.get('color_name_id')?.touched)" required>
                                        <option *ngFor="let c of colorList;" value="{{c.id}}">{{c.name}}</option>
                                    </select>
                                    <div class="text-danger text-end w-100" *ngIf="formGroup.get('color_name_id')?.invalid && (theForm.submitted || formGroup.get('color_name_id')?.touched)">
                                        <small *ngIf="formGroup.get('color_name_id')?.errors?.required">Select text</small>
                                        <small *ngIf="formGroup.get('color_name_id')?.errors?.serverError">{{formGroup.get('color_name_id')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="formGroup.get('type')?.value=='incongruent'" class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Color</label>
                                </div>
                                <div class="col-md-8">
                                    <select formControlName="color_code_id" class="form-select" [class.is-invalid]="formGroup.get('color_code_id')?.invalid && (theForm.submitted || formGroup.get('color_code_id')?.touched)" required>
                                        <option *ngFor="let c of colorList;" value="{{c.id}}">{{c.name}}</option>
                                    </select>
                                    <div class="text-danger text-end w-100" *ngIf="formGroup.get('color_code_id')?.invalid && (theForm.submitted || formGroup.get('color_code_id')?.touched)">
                                        <small *ngIf="formGroup.get('color_code_id')?.errors?.required">Select color</small>
                                        <small *ngIf="formGroup.get('color_code_id')?.errors?.serverError">{{formGroup.get('color_code_id')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label>Voice</label>
                                </div>
                                <div class="col-md-8">
                                    <div class="input-group">
                                        <input class="form-control" placeholder="Choose file" [value]="voice?.view ?? ''" readonly (click)="inputVoice.click()">
                                        <button type="button" class="btn btn-outline-primary" (click)="inputVoice.click()">
                                            <i class="material-icons">search</i>
                                        </button>
                                        <input class="d-none" #inputVoice accept=".mp3" (change)="fileHandler.handle($event, voice, 'audio/mpeg,audio/x-mpeg3,audio/mpeg3', (0.5))" type="file">
                                    </div>
                                    <small>FileType: mp3, size: 500KB</small>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center border-top pt-4 mt-4">
                            <div>
                                <div class="form-check">
                                    <input class="form-check-input" [(ngModel)]="stayPage" [ngModelOptions]="{standalone: true}" type="checkbox" id="stayPage" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <label class="form-check-label" for="stayPage">
                                        Stay on this page
                                    </label>
                                </div>
                            </div>
                            <div class="text-end">
                                <button type="button" class="btn btn-secondary" (click)="back();" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">close</i> &nbsp;
                                    Cancel
                                </button>
                                &nbsp;
                                <button type="submit" class="btn btn-primary" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">save</i> &nbsp;
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
